import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function setPages({ commit }, pages) {
  commit(types.SET_PAGES, pages);

  return Promise.resolve(pages);
}

export function setPageList({ commit }, { cardId, pageList }) {
  commit(types.SET_PAGE_LIST, { cardId, pageList });

  return Promise.resolve(pageList);
}

export function setPagesPagination({ commit }, pagination) {
  commit(types.SET_PAGINATION, pagination);

  return Promise.resolve(pagination);
}

export function fetchPageList({ dispatch }, cardId) {
  return http.get(`${MINERVA_API_URL}/assignments/${cardId}/pages`)
    .then(resp => (
      dispatch('setPageList', {
        pageList: resp.data,
        cardId,
      })
    ));
}

export function fetchPages({ dispatch }, { cardId, page }) {
  return http.get(`${MINERVA_API_URL}/assignments/${cardId}/pages/${page}`)
    .then((resp) => {
      dispatch('setPages', {
        cardId,
        pages: resp.data,
      });
    });
}

export function fetchPagesPagination({ dispatch }, { page, total }) {
  const perPage = 1;

  dispatch('setPagesPagination', {
    total: Number(total),
    totalPages: Number(total) / Number(perPage),
    page: Number(page),
    perPage: Number(perPage),
  });
}

export function saveQuizValue({ commit }, { quiz, value }) {
  return commit(types.SET_QUIZ_VALUE, { quiz, value });
}

export function saveQuizOption({ commit }, { quiz, option }) {
  return commit(types.SET_QUIZ_OPTION, { quiz, option });
}

export function setSelectedOptions({ commit }, { option }) {
  return commit(types.SET_SELECT_OPTIONS, { option });
}

export function resetSelectedOptions({ commit }) {
  commit(types.RESET_SELECT_OPTIONS);
}

export function resetEnteredValue({ commit }) {
  commit(types.RESET_ENTERED_VALUE);
}

export function setWrongPageList({ commit }, wrongPageList) {
  commit(types.SET_WRONG_PAGE_LIST, wrongPageList);
}

export function resetWrongPageList({ commit }) {
  commit(types.RESET_WRONG_PAGE_LIST);
}

export function resetQuizStartTime({ commit }) {
  return commit(types.RESET_QUIZ_START_TIME);
}
